import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { NewsModel } from './../../../../models/News.model';

@Component({
  selector: 'app-post-medium',
  templateUrl: './post-medium.component.html',
  styleUrls: ['./post-medium.component.scss'],
  standalone: false,
})
export class PostMediumComponent implements AfterViewInit {
  constructor(public translateService: TranslateService) {
    this.isIphone = /iPhone/i.test(navigator.userAgent);
  }

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  isIphone = false;
  public videoCaminhosPath = environment.videoCaminhosPath;
  @Input() dashboard = false;
  @Input() news_data: NewsModel = new NewsModel();
  @Input() relatedNews = false;
  @Input() fill_width = false;

  resize = false;

  width: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.width = window.innerWidth;
    this.resize = true;
  }

  ngAfterViewInit() {
    if (
      this.videoPlayer != undefined &&
      this.news_data.internVideo &&
      !this.news_data.internVideo.includes('video_caminhos')
    ) {
      const video = this.videoPlayer.nativeElement;
      video.currentTime = 1;
    }
  }

  getRowHeight() {
    let vhByPx = 0.0116809663250366;
    return window.innerWidth * vhByPx;
  }

  getLocalized(field: any): string {
    if (!field) {
      return '';
    }
    if (typeof field === 'string') {
      return field;
    }
    const lang = this.translateService.currentLang || 'pt';
    return field[lang] || field['pt'] || '';
  }
}
